/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type SSOPage_viewer$ref = any;
export type SSOPage_QueryVariables = {
    readonly clientId: string;
};
export type SSOPage_QueryResponse = {
    readonly viewer: ({
        readonly id: string | null;
        readonly " $fragmentRefs": SSOPage_viewer$ref;
    }) | null;
};
export type SSOPage_Query = {
    readonly response: SSOPage_QueryResponse;
    readonly variables: SSOPage_QueryVariables;
};



/*
query SSOPage_Query(
  $clientId: String!
) {
  viewer {
    id
    ...SSOPage_viewer_3sjgMp
  }
}

fragment SSOPage_viewer_3sjgMp on Viewer {
  id
  isLoggedIn
  user {
    id
    userId
  }
  sso(clientId: $clientId) {
    name
    url
    ssoClientId
    id
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "clientId",
            "type": "String!",
            "defaultValue": null
        } as any)
    ], v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "SSOPage_Query",
            "type": "Root",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v1 /*: any*/),
                        {
                            "kind": "FragmentSpread",
                            "name": "SSOPage_viewer",
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "clientId",
                                    "variableName": "clientId",
                                    "type": null
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "SSOPage_Query",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v1 /*: any*/),
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "isLoggedIn",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "user",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "User",
                            "plural": false,
                            "selections": [
                                (v1 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "userId",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "sso",
                            "storageKey": null,
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "clientId",
                                    "variableName": "clientId",
                                    "type": "String"
                                }
                            ],
                            "concreteType": "SSO",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "name",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "url",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "ssoClientId",
                                    "args": null,
                                    "storageKey": null
                                },
                                (v1 /*: any*/)
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "SSOPage_Query",
            "id": null,
            "text": "query SSOPage_Query(\n  $clientId: String!\n) {\n  viewer {\n    id\n    ...SSOPage_viewer_3sjgMp\n  }\n}\n\nfragment SSOPage_viewer_3sjgMp on Viewer {\n  id\n  isLoggedIn\n  user {\n    id\n    userId\n  }\n  sso(clientId: $clientId) {\n    name\n    url\n    ssoClientId\n    id\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'd85fefc6cf773dd3e82086e3bd481ad0';
export default node;
